import React, { useEffect } from 'react';
import { useSearch } from '@shared/lib/hooks/useSearch';
import { useLocation } from "react-router-dom";
import "./SearchBar.css"
interface SearchBarProps {
  className?: string;
  placeholder?: string;
}

export const SearchBar: React.FC<SearchBarProps> = React.memo(({
  className = '',
  placeholder = 'Search'
}) => {
  const { searchQuery, setSearchQuery, handleSearchSubmit } = useSearch();


  const location = useLocation(); // Получаем текущий URL

  useEffect(() => {
    setSearchQuery(""); // Сбрасываем значение поля поиска при изменении URL
  }, [location]); // Запускаем эффект при изменении URL


  return (
    <form 
      className={`search-form ${className}`}
      onSubmit={handleSearchSubmit}
    >
      <input
        type="text"
        placeholder={placeholder}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="search-input text-[20px]"
      />
      <button type="submit" aria-label="Submit search">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 50 50"
          width="25px"
          height="25px"
        >
          <path d="M 21 3 C 11.601563 3 4 10.601563 4 20 C 4 29.398438 11.601563 37 21 37 C 24.355469 37 27.460938 36.015625 30.09375 34.34375 L 42.375 46.625 L 46.625 42.375 L 34.5 30.28125 C 36.679688 27.421875 38 23.878906 38 20 C 38 10.601563 30.398438 3 21 3 Z M 21 7 C 28.199219 7 34 12.800781 34 20 C 34 27.199219 28.199219 33 21 33 C 13.800781 33 8 27.199219 8 20 C 8 12.800781 13.800781 7 21 7 Z" />
        </svg>
      </button>
    </form>
  );
}); 